import { NotificationPreferences } from './model/types';

export const NOTIFICATION_PROMPT_KEY = 'notificationPromptDismissed';

export const defaultPreferencesEnabled: NotificationPreferences = {
  jobs: {
    email: true,
    push: true
  },
  marketing: {
    email: true,
    push: true
  }
};

export const defaultPreferencesDisabled: NotificationPreferences = {
  jobs: {
    email: true,
    push: false
  },
  marketing: {
    email: false,
    push: false
  }
};
